export const liftTypesByCategory = [
    {
        categories: ['shoppingAreaRent', 'shoppingAreaSale', 'buildingRent', 'buildingSale'],
        liftTypes: [{
            text: 'лифты',
            genitiveName: 'Лифтов',
            value: 'lift'
        }, {
            text: 'травалаторы',
            genitiveName: 'Травалаторов',
            value: 'travelator'
        }, {
            text: 'эскалаторы',
            genitiveName: 'Эскалаторов',
            value: 'escalator'
        }]
    },
    {
        categories: ['warehouseRent', 'warehouseSale', 'industryRent', 'industrySale'],
        liftTypes: [{
            text: 'Грузовой',
            genitiveName: 'Грузовых лифтов',
            value: 'cargo'
        }, {
            text: 'Тельфер',
            genitiveName: 'Тельферов',
            value: 'telpher'
        }, {
            text: 'Пассажирский',
            genitiveName: 'Пассажирских лифтов',
            value: 'passenger'
        }]
    }
];

export function getLiftTypesByCategory(category) {
    const el = liftTypesByCategory.find(i => i.categories.contains(category));
    if (el)
        return el.liftTypes;
}
